import { typeIds } from "constants/typeId";

const visitFirst = [
  {
    value: "no",
    label: "No",
  },
  {
    value: "si",
    label: "Si",
  },
];

export const typeTicket = [
  {
    value: "vip",
    label: "VIP",
  },
  {
    value: "preferencial",
    label: "Preferencial",
  },
  {
    value: "general",
    label: "General",
  },
];

export const resevationForm = {
  formName: "reservation",
  textInputs: [
    {
      name: "first",
      label: "¿Es la primera vez que asistes a la iglesia El Camino?",
      type: "select",
      options: visitFirst,
    },
    {
      name: "typeId",
      label: "Tipo de identificación*",
      type: "select",
      required: false,
      options: typeIds,
    },
    {
      name: "numberId",
      label: "Número de identificación",
      type: "number",
      required: true,
    },
    {
      name: "name",
      label: "Nombres",
      type: "text",
      required: true,
    },
    {
      name: "lastName",
      label: "Apellidos",
      type: "text",
      required: true,
    },
    {
      name: "birthday",
      label: "Fecha de nacimiento",
      type: "date",
      required: true,
    },
    {
      name: "cellphone",
      label: "Número de celular",
      type: "number",
      required: true,
    },
    {
      name: "email",
      label: "Correo electrónico",
      type: "email",
      required: true,
    },
    {
      name: "vaccination",
      label: "¿Ya completaste tu esquema de vacunación?",
      type: "select",
      options: visitFirst,
    },
  ],
};
